module.exports = __webpack_public_path__ + "static/media/007.e5f004eb.jpg";